// src/OurProjects.js

import React, { useEffect, useState, useRef } from 'react';

import { Helmet } from 'react-helmet';

import { db } from './firebase';

import { collection, getDocs } from 'firebase/firestore';

import './App.css';



const OurProjects = () => {

  const [projects, setProjects] = useState([]);

  const [loading, setLoading] = useState(true);

  const topRef = useRef(null);



  useEffect(() => {

    const fetchProjects = async () => {

      try {

        const querySnapshot = await getDocs(collection(db, 'projects'));

        const projectsList = querySnapshot.docs.map(doc => ({

          id: doc.id,

          ...doc.data(),

        }));

        setProjects(projectsList);

      } catch (error) {

        console.error("Error fetching projects:", error);

      } finally {

        setLoading(false);

      }

    };

    fetchProjects();

  }, []);



  useEffect(() => {

    if (!loading && topRef.current) {

      topRef.current.scrollIntoView({ behavior: 'smooth' });

    }

  }, [loading]);



  if (loading) {

    return <div>Loading...</div>;

  }



  if (projects.length === 0) {

    return <div>No projects available</div>;

  }



  return (

    <div ref={topRef}>
      <Helmet>
        <title>Human Touch Labs - Web Development & Software Solutions</title>
        <meta name="description" content="Human Touch Labs - A Chicago Based Web Development and Software Development Firm; Specialist in Refined and Rapid Web and Software Development." />
        <meta name="keywords" content="Human Touch Labs, Web Designers, Web Developers, Software Developers, Web Design, Website Creation, Web Host Management, Web Integrations, Website Maintenance, Domain Management, Search Engine Optimization, Game Website Creation, User Account Management, Graphic Design, Custom Enterprise Software, Small Software Solutions, Digital Logistics, Software Integrations, Software Diagnostics, Software Optimization, Testing Tool Creation, Software Automation, Game Development Tools, Chicago, htl" />
        <meta name="robots" content="index" />
      </Helmet>

      <div className="box-container">

        {projects.map(project => (

          <div key={project.id} className="box" onClick={() => window.open(project.Hyperlink, '_blank')}>

            <h3>{project.Title}</h3>

            <p>{project.Text}</p>

          </div>

        ))}

      </div>

    </div>

  );

};



export default OurProjects;

